import React, { useState, useEffect, useRef } from 'react';
import { submitForm } from '../utils/formSubmit';
import Swal from 'sweetalert2';
import { FaWhatsapp } from 'react-icons/fa';
import './UsaContactSection.css';

// Embedded inline SVG US Flag
const UsFlag = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 650 390"
    style={{ borderRadius: '2px', display: 'inline-block', verticalAlign: 'middle', width: '22px', height: '14px', flexShrink: 0 }}
  >
    <rect width="650" height="390" fill="#b22234" />
    <path d="M0 30h650M0 90h650M0 150h650M0 210h650M0 270h650M0 330h650" stroke="#fff" strokeWidth="30" />
    <rect width="260" height="210" fill="#3c3b6e" />
    <g fill="#fff">
      <circle cx="26" cy="21" r="9" />
      <circle cx="78" cy="21" r="9" />
      <circle cx="130" cy="21" r="9" />
      <circle cx="182" cy="21" r="9" />
      <circle cx="234" cy="21" r="9" />
      <circle cx="52" cy="52.5" r="9" />
      <circle cx="104" cy="52.5" r="9" />
      <circle cx="156" cy="52.5" r="9" />
      <circle cx="208" cy="52.5" r="9" />
      <circle cx="26" cy="84" r="9" />
      <circle cx="78" cy="84" r="9" />
      <circle cx="130" cy="84" r="9" />
      <circle cx="182" cy="84" r="9" />
      <circle cx="234" cy="84" r="9" />
      <circle cx="52" cy="115.5" r="9" />
      <circle cx="104" cy="115.5" r="9" />
      <circle cx="156" cy="115.5" r="9" />
      <circle cx="208" cy="115.5" r="9" />
      <circle cx="26" cy="147" r="9" />
      <circle cx="78" cy="147" r="9" />
      <circle cx="130" cy="147" r="9" />
      <circle cx="182" cy="147" r="9" />
      <circle cx="234" cy="147" r="9" />
      <circle cx="52" cy="178.5" r="9" />
      <circle cx="104" cy="178.5" r="9" />
      <circle cx="156" cy="178.5" r="9" />
      <circle cx="208" cy="178.5" r="9" />
    </g>
  </svg>
);

const countryList = [
  { name: 'United States', code: '+1', iso: 'us' }
];

const UsaContactSection = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    course: 'Noorani Qaida',
    phone: '',
    message: ''
  });

  const [selectedCountry, setSelectedCountry] = useState(countryList[0]);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const countryDropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (countryDropdownRef.current && !countryDropdownRef.current.contains(e.target)) {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await submitForm('Contact Us Consultation Form', {
        fullName: `${formData.firstName} ${formData.lastName}`.trim(),
        email: 'Not Provided (Contact Form)',
        phone: `${selectedCountry.code} ${formData.phone}`,
        course: formData.course,
        message: formData.message
      });

      Swal.fire({
        title: 'Trial Booked Successfully!',
        text: `Thank you, ${formData.firstName}! Our team will reach out to schedule your free trial session.`,
        icon: 'success',
        confirmButtonColor: '#006100'
      });

      setFormData({
        firstName: '',
        lastName: '',
        course: 'Noorani Qaida',
        phone: '',
        message: ''
      });
      window.location.href = '/thank-you-enrollment-successful/';
    } catch (error) {
      Swal.fire({
        title: 'Error!',
        text: 'Failed to submit form. Please try again.',
        icon: 'error',
        confirmButtonColor: '#006100'
      });
    } finally {
      setSubmitting(false);
    }
  };

  const filteredCountries = countryList.filter(
    (c) =>
      c.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      c.code.includes(searchQuery)
  );

  return (
    <section className="usa-contact-section" id="contact">
      <div className="usa-contact-section__container">
        {/* Top Header Block */}
        <div className="usa-contact-section__header">
          <h2 className="usa-contact-section__title">
            Let's Talk About Your Quran Classes Online
          </h2>
          <p className="usa-contact-section__subtitle">
            Tell us about your learning objectives so that we can associate you with the right tutor. Fill out the form below. Our online Quran classes team reaches out to schedule your free trial sessions.
          </p>
        </div>

        {/* Two Column Grid */}
        <div className="usa-contact-section__grid">
          {/* Left Column: Form Card */}
          <div className="usa-contact-card">
            <form onSubmit={handleSubmit} className="usa-contact-form">
              {/* First Name & Last Name Row */}
              <div className="usa-contact-form-row">
                <input
                  type="text"
                  name="firstName"
                  placeholder="First Name"
                  value={formData.firstName}
                  onChange={handleChange}
                  required
                  className="usa-contact-input"
                />
                <input
                  type="text"
                  name="lastName"
                  placeholder="Last Name"
                  value={formData.lastName}
                  onChange={handleChange}
                  required
                  className="usa-contact-input"
                />
              </div>

              {/* Course Select Dropdown */}
              <div className="usa-contact-form-group">
                <select
                  name="course"
                  value={formData.course}
                  onChange={handleChange}
                  required
                  className="usa-contact-select"
                >
                  <option value="Noorani Qaida">Noorani Qaida</option>
                  <option value="Quran Tajweed Classes">Quran Tajweed Classes</option>
                  <option value="Quran Reading Classes">Quran Reading Classes</option>
                  <option value="Quran Memorization Classes">Quran Memorization Classes</option>
                  <option value="Quran Translation Classes">Quran Translation Classes</option>
                </select>
              </div>

              {/* Phone Input with US Flag Picker */}
              <div className="usa-contact-form-group" ref={countryDropdownRef} style={{ position: 'relative' }}>
                <div className="usa-contact-phone-box">
                  <button
                    type="button"
                    className="usa-contact-country-btn"
                    onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                  >
                    <UsFlag />
                    <span className="usa-contact-arrow">▲</span>
                    <span className="usa-contact-code">{selectedCountry.code}</span>
                  </button>
                  <span className="usa-contact-divider">|</span>
                  <input
                    type="tel"
                    name="phone"
                    placeholder="Phone Number"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                    className="usa-contact-phone-input"
                  />
                </div>

                {/* Country Code Dropdown */}
                {isDropdownOpen && (
                  <div className="usa-contact-country-dropdown">
                    <div className="usa-contact-search-wrapper">
                      <input
                        type="text"
                        placeholder="Search"
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        className="usa-contact-search-input"
                        autoFocus
                      />
                    </div>
                    <ul className="usa-contact-country-menu">
                      {filteredCountries.map((c) => (
                        <li
                          key={c.name}
                          className={`usa-contact-country-option ${c.name === selectedCountry.name ? 'usa-contact-country-option--active' : ''}`}
                          onClick={() => {
                            setSelectedCountry(c);
                            setIsDropdownOpen(false);
                            setSearchQuery('');
                          }}
                        >
                          <span className="usa-contact-opt-flag">
                            <UsFlag />
                          </span>
                          <span className="usa-contact-opt-name">{c.name}</span>
                          <span className="usa-contact-opt-code">{c.code}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>

              {/* Message Field */}
              <div className="usa-contact-form-group">
                <input
                  type="text"
                  name="message"
                  placeholder="Message"
                  value={formData.message}
                  onChange={handleChange}
                  className="usa-contact-input"
                />
              </div>

              {/* Submit Button */}
              <button
                type="submit"
                disabled={submitting}
                className="usa-contact-submit-btn"
              >
                {submitting ? 'Booking Trial...' : 'Book My Free Trial'}
              </button>
            </form>
          </div>

          {/* Right Column: CONTACT INFO matching screenshot */}
          <div className="usa-contact-info">
            <h3 className="usa-contact-info__title">CONTACT INFO</h3>

            <ul className="usa-contact-info__list">
              {/* Location Item */}
              <li className="usa-contact-info__item">
                <div className="usa-contact-info__icon-wrapper">
                  <svg className="usa-contact-info__icon" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                    <path strokeLinecap="round" strokeLinejoin="round" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
                </div>
                <p className="usa-contact-info__link">
                  1942 BROADWAY ST STE 314C, 80302, BOULDER, United States
                </p>
              </li>

              {/* WhatsApp Item */}
              <li className="usa-contact-info__item">
                <div className="usa-contact-info__icon-wrapper">
                  <FaWhatsapp className="usa-contact-info__icon" />
                </div>
                <a href="https://wa.me/17164577657" target="_blank" rel="noopener noreferrer" className="usa-contact-info__link">
                  716-457-7657
                </a>
              </li>

              {/* Phone USA Item */}
              <li className="usa-contact-info__item">
                <div className="usa-contact-info__icon-wrapper">
                  <svg className="usa-contact-info__icon" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.94.725l.548 2.2a1 1 0 01-.321.988l-1.305.98a10.582 10.582 0 004.872 4.872l.98-1.305a1 1 0 01.988-.321l2.2.548a1 1 0 01.725.94V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                  </svg>
                </div>
                <a href="tel:+17164577657" className="usa-contact-info__link">
                  +1 716 457 7657 (USA)
                </a>
              </li>

              {/* Email Item */}
              <li className="usa-contact-info__item">
                <div className="usa-contact-info__icon-wrapper">
                  <svg className="usa-contact-info__icon" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                </div>
                <a href="mailto:info@alquranlesson.com" className="usa-contact-info__link">
                  info@alquranlesson.com
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default UsaContactSection;
